import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'components/icon/icon.component';
import { merge } from 'lodash';

interface FontSettings {
    size?: number;
    color?: string;
    weight?: string | number;
    lineHeight?: number;
}

interface ActionButton {
    disabled?: boolean;
    textKey: string;
    translationParams?: { [key: string]: any };
    textFontSettings?: FontSettings;
    /**
     * The font awesome icon string to use for the submit button.
     * @example 'fa-solid fa-check'
     * @example 'fa-solid fa-paper-plane'
     */
    faIconText?: string;
    iconFontSettings?: FontSettings;
    onPress: () => void;
}

export interface DropdownActionButtonOptions {
    mainButton: ActionButton;
    mainButtonClass?: string;
    dropdownButtons: ActionButton[];
    dropdownDisabled?: boolean;
    buttonHeight?: number;
}

@Component({
    selector: 'app-dropdown-action-button',
    templateUrl: './dropdown-action-button.component.html',
    styleUrls: ['./dropdown-action-button.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatMenuModule,
        TranslateModule,
        IconComponent,
    ],
})
export class DropdownActionButtonComponent implements OnChanges, OnInit {
    static readonly defaultOptions: Partial<DropdownActionButtonOptions> = {
        mainButtonClass: 'blue-lt',
        dropdownDisabled: false,
    };

    @Input() options: DropdownActionButtonOptions;
    @Input() mainButton: ActionButton;
    @Input() mainButtonClass: string;
    @Input() dropdownButtons: ActionButton[];
    @Input() dropdownDisabled: boolean;

    @ViewChild('mainButton') mainButtonElement: ElementRef;

    ngOnChanges(): void {
        this.mergeOptions();
    }

    ngOnInit(): void {
        this.mergeOptions();
    }

    private mergeOptions() {
        this.options = merge(
            {},
            DropdownActionButtonComponent.defaultOptions,
            this.options,
            {
                mainButton: this.mainButton,
                mainButtonClass: this.mainButtonClass,
                dropdownButtons: this.dropdownButtons,
                dropdownDisabled: this.dropdownDisabled,
            },
        );
    }
}